import { notification } from 'antd';
import { services } from '../../../API';
import { useCallback, useEffect, useState } from 'react';
import { PrivacyPolicyModal } from './PrivacyPolicyModal';

export const PrivacyPolicy = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handlePrivacyPolicyClose = useCallback(() => {
    services.auth.cancelPrivacyPolicy();
    setIsVisible(false);
  }, []);

  const handlePrivacyPolicyOpen = useCallback(() => {
    setIsVisible(true);
  }, []);

  const handlePrivacyPolicyAccept = useCallback(async () => {
    try {
      await services.auth.acceptPrivacyPolicy();

      handlePrivacyPolicyClose();
    } catch (e) {
      const title = 'Не удалось войти в аккаунт';
      const description =
        'Пожалуйста, вернитесь на страницу входа и попробуйте ещё раз. Убедитесь, что введенные данные верны. Если проблема сохранится - обратитесь в техподдержку';

      notification.error({
        title,
        description,
      });
    }
  }, []);

  useEffect(() => {
    services.auth.onPrivacyPolicyNotAgreed(handlePrivacyPolicyOpen);

    return () => {
      services.auth.unPrivacyPolicyNotAgreed(handlePrivacyPolicyOpen);
    };
  }, [handlePrivacyPolicyOpen]);

  if (!isVisible) return <></>;

  return (
    <PrivacyPolicyModal
      isVisible={isVisible}
      onClose={handlePrivacyPolicyClose}
      onAccept={handlePrivacyPolicyAccept}
    />
  );
};
